// extracted by mini-css-extract-plugin
module.exports = {"historyTabsWrapper":"HistoryTabs_historyTabsWrapper__c7BYS","contentContainer":"HistoryTabs_contentContainer__1bTL0","orderDetails":"HistoryTabs_orderDetails__CKkEV"};